export default {"src":"/_next/static/media/insurance.4dca2dc9.svg","height":430,"width":430,"blurWidth":0,"blurHeight":0};